<template>
  <div>
    <!-- Mobile: single day view (< 992px) -->
    <div class="mobile-schedule">
      <DaysOfWeekPicker :onChange="dayOfWeekChange"/>
      <Loader :display="loading" />
      <transition-group name="opacity">
        <div v-for="schedule in displaySchedules" :key="schedule.id" class="px-1 mb-1">
          <a :href="editRoute.replace(':id', schedule.id)" @click.prevent="$emit('edit', schedule)">
            <div class="bg-dark px-4 py-2 d-block d-flex justify-content-start align-items-center rounded clickable">
              <span class="pr-2 text-primary"><FontAwesomeIcon icon="chevron-right" /></span>
              <slot name="mobile-item" :schedule="schedule"></slot>
              <span :style="{ display: deletingSchedules.has(schedule.id) ? 'inline-block' : 'none'}" class="p-2 ml-auto">
                <FontAwesomeIcon icon="spinner" spin />
              </span>
              <span
                @click="onDelete($event, schedule)"
                :style="{ display: !deletingSchedules.has(schedule.id) ? 'inline-block' : 'none'}"
                class="p-2 ml-auto"
              >
                <FontAwesomeIcon icon="times" class="text-danger" />
              </span>
            </div>
          </a>
        </div>
      </transition-group>
      <div class="px-1 mb-1">
        <a :href="addRoute" @click.prevent="$emit('create', selectedDayOfWeek)">
          <div class="bg-gray text-center text-primary clickable rounded px-4 py-3">{{addButtonText}}</div>
        </a>
      </div>
    </div>

    <!-- Desktop: full week view (>= 992px) -->
    <div class="desktop-schedule">
      <Loader :display="loading" />
      <div v-if="!loading" class="week-grid">
        <div
          v-for="(day, dayIndex) in daysOfWeek"
          :key="dayIndex"
          class="week-day-column"
        >
          <div class="week-day-header">
            <span>{{ day.upperCaseName }}</span>
          </div>
          <div class="week-day-body">
            <div
              v-for="schedule in schedulesForDay(dayIndex)"
              :key="schedule.id"
              class="mb-1"
            >
              <a :href="editRoute.replace(':id', schedule.id)" @click.prevent="$emit('edit', schedule)">
                <div class="bg-dark px-2 py-2 d-flex align-items-center rounded clickable week-schedule-item">
                  <slot name="desktop-item" :schedule="schedule"></slot>
                  <span :style="{ display: deletingSchedules.has(schedule.id) ? 'inline-block' : 'none'}" class="p-1 ml-auto">
                    <FontAwesomeIcon icon="spinner" spin />
                  </span>
                  <span
                    @click="onDelete($event, schedule)"
                    :style="{ display: !deletingSchedules.has(schedule.id) ? 'inline-block' : 'none'}"
                    class="p-1 ml-auto"
                  >
                    <FontAwesomeIcon icon="times" class="text-danger" />
                  </span>
                </div>
              </a>
            </div>
            <div class="mt-1">
              <a href="#" @click.prevent="$emit('create', dayIndex)">
                <div class="bg-gray text-center text-primary clickable rounded px-2 py-2">
                  <small><FontAwesomeIcon icon="plus" /> {{$t('Add')}}</small>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import days from '@/utils/days'

export default {
  name: 'ScheduleLayout',

  props: {
    schedules: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    deletingSchedules: {
      type: Set,
      default: () => new Set()
    },
    editRoute: {
      type: String,
      required: true
    },
    addRoute: {
      type: String,
      required: true
    },
    addButtonText: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      selectedDayOfWeek: 0,
      daysOfWeek: days
    }
  },

  computed: {
    displaySchedules () {
      return this.schedules
        .filter((schedule) => schedule.start_day === this.selectedDayOfWeek)
        .sort((a, b) => a.start_time.localeCompare(b.start_time))
    }
  },

  methods: {
    schedulesForDay (dayIndex) {
      return this.schedules
        .filter((schedule) => schedule.start_day === dayIndex)
        .sort((a, b) => a.start_time.localeCompare(b.start_time))
    },
    dayOfWeekChange (value) {
      this.selectedDayOfWeek = value
    },
    onDelete (e, schedule) {
      e.preventDefault()
      e.stopPropagation()
      this.$emit('delete', schedule)
    }
  }
}
</script>

<style scoped>
/* Mobile: show single-day view, hide weekly view */
.mobile-schedule {
  display: block;
}
.desktop-schedule {
  display: none;
}

/* Desktop (>= 992px): hide single-day view, show weekly view */
@media (min-width: 992px) {
  .mobile-schedule {
    display: none;
  }
  .desktop-schedule {
    display: block;
  }

  .week-grid {
    display: flex;
    gap: 8px;
    padding: 0 4px;
  }

  .week-day-column {
    flex: 1;
    min-width: 0;
  }

  .week-day-header {
    text-align: center;
    padding: 10px 4px;
    font-weight: 600;
    font-size: 0.85rem;
    letter-spacing: 0.5px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 8px;
  }

  .week-day-body {
    min-height: 100px;
  }

  .week-schedule-item {
    font-size: 0.85rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/ScheduleLayout.vue